import { getEnv } from '../utils/environment';
import { simpleFetch } from './customFetch';

export const getMyBoxDetails = () => simpleFetch('/box-status');

export const getMyBoxRate = (options = {}) =>
  simpleFetch('/ratings/self', options, getEnv().REACT_APP_QUESTIONNAIRE_API);
